import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { ContasReceberCopiaForm, ContasReceberCopiaSchema, defaultContasReceberCopiaForm } from "../../../schemas/ContasReceber_lista/ContasReceber_copia";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

type props = {
    open: boolean,
    saving: boolean,
    selectedIdContaReceber: number,
    titulo: string,
    onClose: () => void,
    onSubmit: (form: ContasReceberCopiaForm) => void,

}

export const CopiaContaReceberModal = ({
    open,
    saving,
    selectedIdContaReceber,
    titulo,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<ContasReceberCopiaForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultContasReceberCopiaForm,
        resolver: zodResolver(ContasReceberCopiaSchema),
    });

    useEffect(() => {
        hookForm.setValue('idContaReceber', selectedIdContaReceber);
        hookForm.setValue('titulo', titulo);

    }, [selectedIdContaReceber, titulo, hookForm]);

    const handleSubmit = useCallback((form: ContasReceberCopiaForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Copiar Conta a Receber
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <DefaultFormInput
                                name='titulo'
                                label='Conta Origem'
                                readOnly={true}
                                reactHookForm={hookForm}

                            />

                            <FormMaskedInput
                                name={'nroCopias'}
                                label={"Número de Cópias"}
                                mask='00'
                                maskPlaceholder="__"
                                reactHookForm={hookForm}
                            />

                            <FormRadioGroupInput
                                name='tipoData'
                                label='Data a Receber'
                                options={[
                                    { id: 0, label: 'Projetar Meses Futuros' },
                                    { id: 1, label: 'Preencher Data' },
                                    { id: 2, label: 'Manter Data Item copiado' },
                                ]}
                                reactHookForm={hookForm} />
                            {
                                Number(hookForm.watch("tipoData")) === 1 && <div className="mb-2 mt-2 ">
                                    <FormDatePickerInput
                                        name='dataRecebimento'
                                        label='Data a Receber'
                                        required={false}
                                        reactHookForm={hookForm}
                                    />

                                </div>
                            }

                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}